import { EnvironmentDescription, View } from "@novorender/api";
import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { selectConfig } from "slices/explorer";
import { AsyncStatus } from "types/misc";

import { renderActions, selectBackground } from "../renderSlice";

export function useHandleBackground() {
    const {
        state: { view },
    } = useExplorerGlobals();
    const { environments, color, url, blur, alpha } = useAppSelector(selectBackground);
    const config = useAppSelector(selectConfig);
    const dispatch = useAppDispatch();

    useEffect(() => {
        loadEnvs();

        async function loadEnvs() {
            if (!view || environments.status !== AsyncStatus.Initial) {
                return;
            }

            dispatch(renderActions.setBackground({ environments: { status: AsyncStatus.Loading } }));
            const url = `${config.assetsUrl}/env/index.json`;
            const envs = await View.availableEnvironments(new URL(url));
            dispatch(
                renderActions.setBackground({
                    environments: { status: AsyncStatus.Success, data: envs as EnvironmentDescription[] },
                }),
            );
        }
    }, [view, dispatch, environments, config.assetsUrl]);

    useEffect(
        function handleBackgroundChange() {
            if (!view) {
                return;
            }

            view.modifyRenderState({
                background: { color: [color[0], color[1], color[2]], url: url || undefined, blur, alpha },
            });
        },
        [view, color, url, blur, alpha],
    );
}
